<template>
  <div>
    <div class="ibox">
      <div class="ibox-content">

        <div class="margin-20"></div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group-outer">
              <div class="form-group float-label-control" :class="{'has-error': errors.has('name')}">
                <label for="">Name</label>
                <input type="text" v-model="name" v-validate="'required'" name="name" class="form-control" placeholder="Name" v-float-label />
              </div>
            </div><!-- /.form-group-outer -->
          </div>
          <div class="col-md-6">
            <div class="form-group-outer">
              <div class="form-group float-label-control" :class="{'has-error': errors.has('mobile')}">
                <label for="">Mobile Number</label>
                <input type="text" v-model="mobile" v-validate="" name="mobile" class="form-control" placeholder="Mobile Number" v-float-label/>
              </div>
            </div><!-- /.form-group-outer -->
          </div>
        </div><!-- /.row -->

        <div class="form-group-outer" :class="{'has-error': errors.has('email')}">
          <div class="form-group float-label-control">
            <label for="">Email Address</label>
            <input type="text" v-model="email" v-validate="" name="email" class="form-control" placeholder="Email Address" v-float-label />
          </div>
        </div><!-- /.form-group-outer -->

        <div class="row">
          <div class="col-md-6" v-if="canChangeRole && !accountUser.driver_id">
            <div class="form-group-outer">
              <div class="form-group float-label-control form-group" :class="{'has-error': errors.has('role')}">
                <label for="" class="select-label">Primary Role</label>
                <selectize
                  v-model="roleId"
                  name="role"
                  v-validate:roleId="roleRequired ? 'required' : ''"
                  :options="systemAccessOptions">
                </selectize>
              </div>
            </div><!-- /.form-group-outer -->
          </div>
          <div class="col-md-6">
            <strong>Last access:</strong> {{ lastLogin }}
          </div>
        </div><!-- /.row -->

      </div>
    </div><!-- /.ibox -->

    <div class="margin-20"></div>

    <div class="row" v-if="isDriver && (accountUser.driver_profile.id || loggedInUserIsAdmin)">
      <div class="col-md-5 col-lg-4">

        <div class="ibox">
          <div class="ibox-content">
            <div class="margin-20"></div>
            <slot name="cropper"/>
          </div>
        </div><!-- /.ibox -->

        <div v-if="loggedInUserIsAdmin" class="ibox">
          <div class="ibox-content">
            <div class="form-group">
              <h3>Current Carriers</h3>

              <ul v-if="carriers && carriers.length && carriers[0].id">
                <li v-for="carrier of carriers" :trick-by="id">
                  {{ carrier.profile.account_name || carrier.profile.company_name }}
                  <a @click.prevent="syncCarriers(carrier.id)" href="#" class="pull-right">
                    <i class="fa fa-times" :id="`carrier-${carrier.id}`"></i>
                  </a>
                </li>
              </ul>

              <label class="control-label">Add Carrier</label>
              <selectize :options="initialUserOptions" v-model="user_id" name="user" :fetch-results="fetchUserResults" />
            </div>

            <div class="text-right">
              <a href="#" class="btn btn-primary btn-sm text-right" @click.prevent="syncCarriers(null)">Add</a>
            </div>
          </div>
        </div><!-- /.ibox -->
      </div>

      <div class="col-md-7 col-lg-8">

        <div class="ibox">
          <div class="ibox-content">

            <div class="margin-20"></div>

            <div class="form-group-outer">
              <div class="form-group float-label-control">
                <label for="">Drivers Licence</label>
                <input type="text" class="form-control" v-model="licence" placeholder="Drivers Licence" :disabled="!loggedInUserIsAdmin" v-float-label/>
              </div>
            </div><!-- /.form-group-outer -->
            <div class="form-group-outer">
              <div class="form-group float-label-control">
                <label for="">Licence Expiry</label>
                <date-range v-model="licenceExpiry" name="expiry" :single-date-picker="true" :disabled="!loggedInUserIsAdmin" opens="right" v-float-label></date-range>
              </div>
            </div><!-- /.form-group-outer -->

          </div>
        </div><!-- /.ibox -->

      </div>
    </div><!-- /.row -->
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import { stateMapper } from 'mixins/user'
  import { Selectize, DateRange, PhotoCropper } from 'components/forms'
  import { SET_ACCOUNT_USER_ATTRIBUTE } from 'vx/mutations'
  import { Roles } from 'utils/user'
  import moment from 'moment'
  import { notify } from 'utils'
  import { uniq } from 'lodash'
  import $ from 'jquery'

  export default {
    props: ['canChangeRole'],
    mixins: [stateMapper],

    data () {
      return {
        initialUserOptions: [],
        user_id: null,
        stateProperty: 'accountUser',
        mutationProperty: SET_ACCOUNT_USER_ATTRIBUTE,
        photo: null,
        originalPhotoDataUri: null,
        carriers: this.accountUser ? (this.accountUser.carriers || []) : []
      }
    },

    components: {
      Selectize,
      DateRange,
      PhotoCropper
    },

    computed: {
      ...mapState('user/accountUsers', ['accountUser']),
      ...mapGetters('user/accountUsers', ['accountUserDecorated']),
      ...mapGetters('user', ['userOptionsWithAll']),

      isDriver () {
        return this.accountUser.role_id === Roles.DRIVER
      },

      loggedInUserIsAdmin () {
        return this.$user.isAdmin
      },

      /**
       * Options for the system access dropdown
       */
      systemAccessOptions () {
        return [
          { id: Roles.CARRIER, text: 'Carrier' },
          { id: Roles.DRIVER, text: 'Driver' }
        ]
      },

      lastLogin () {
        if (this.accountUser.last_login) {
          return moment(this.accountUser.last_login).format('DD/MM/YYYY hh:mm:ssa')
        }
        return 'N/A'
      },

      roleRequired () {
        return this.$user.isCarrier || this.$user.isAdmin
      },

      /**
       * Get and set a users name on their profile.
       */
      name: {
        get () {
          return this.accountUser.profile.full_name
        },

        set (value) {
          this[SET_ACCOUNT_USER_ATTRIBUTE]({ attribute: 'profile.full_name', value })
        }
      }
    },

    created () {
      // when the user get's changed to a driver give them a blank driver_profile object
      this.$watch('isDriver', () => {
        if (this.isDriver && (this.accountUser.driver_profile === null || this.accountUser.driver_profile === undefined)) {
          this[SET_ACCOUNT_USER_ATTRIBUTE]({
            attribute: 'driver_profile',
            value: {
              photo_storage_path: null,
              photo_name: null,
              licence: null,
              licence_expiry: null
            }
          })
        }
      })
    },

    mounted () {
      this.$watch('accountUser', (val, oldVal) => {
        if (val.carriers && !oldVal.carriers) {
          this.carriers = val.carriers
        }
      })
    },

    methods: {
      ...mapMutations('user/accountUsers', [SET_ACCOUNT_USER_ATTRIBUTE]),
      ...mapActions('user', ['getUsers', 'updateDriverDetails']),

      /**
       * When admin types in the user select box we need to fetch more users
       * from the api since the users are paginated.
       */
      fetchUserResults (name, callback) {
        return this.getUsers({ roles: [Roles.CARRIER], name, master: true }).then(response => {
          callback(this.userOptionsWithAll)
        })
      },

      /**
       * https://support.codium.com.au/a/tickets/11848
       * Allow Admin to change carriers of a driver
       */
      syncCarriers (removing = null) {
        let carriers = uniq([this.user_id, ...this.carriers.map(carrier => carrier && carrier.id)]).filter(id => !!id)
        let btn = null

        if (removing) {
          carriers = carriers.filter(carrier => carrier !== removing)
          btn = $(`#carrier-${removing}`)

          btn.removeClass('fa-times').addClass('fa-refresh fa-spin')
        }

        const payload = { carriers, is_driver: true }
        this.updateDriverDetails({ userId: this.accountUser.id, payload }).then(({ data: { carriers } }) => {
          notify.success('Carriers Updated')

          this.carriers = [] // reset
          this.carriers = carriers
          this.user_id = null
          btn && btn.removeClass('fa-refresh fa-spin').addClass('fa-times')
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// UserDetails.vue?07ea3797